var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Inject, Prop, Vue } from 'vue-property-decorator';
import { StyleItemWrapper } from '../StyleItemWrapper';
import ColorPicker from "../../../../../../lib/builtin/components/ColorPicker/index";
let Color = class Color extends Vue {
  get style() {
    return this.stylePanel.style;
  }
  handleSizeChange(value) {
    this.$set(this.style, this.propKey, value);
  }
  render() {
    const h = arguments[0];
    return h(StyleItemWrapper, {
      "attrs": {
        "propKey": this.propKey,
        "title": this.title
      }
    }, [h(ColorPicker, {
      "attrs": {
        "placement": "topRight",
        "value": this.style[this.propKey]
      },
      "on": {
        "change": this.handleSizeChange
      }
    })]);
  }
};
__decorate([Prop()], Color.prototype, "title", void 0);
__decorate([Prop()], Color.prototype, "propKey", void 0);
__decorate([Inject()], Color.prototype, "stylePanel", void 0);
Color = __decorate([Component({})], Color);
export { Color };
//# sourceMappingURL=color.js.map
